<div *ngIf="initialized">
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="mb-0">Change Event Date</h3>

      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('cancel')">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <form (ngSubmit)="onSave()" [formGroup]="formGroup" novalidate>
    <div class="card-body">
      <h5>{{event.workoutName}}</h5>
      <div class="col-md-12 col-lg-6">
        <div class="form-group">
          <label class="form-control-label" for="workoutDate"> Event Date </label>
          <kendo-datepicker placeholder="" class="form-control" formControlName="workoutDate"></kendo-datepicker>
          <div class="invalid-message">
            <div>Event Date is required</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col">
          <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cancel</button>
        </div>
        <div class="col text-right">
          <button type="submit" [promiseBtn]="submitComplete" class="btn btn-primary">Save</button>
        </div>
      </div>
    </div>
  </form>
</div>
